import { useState, useEffect } from "react";
const Practice = ({abc}) => {
  
  return <>aaaaa</>;
};

export default Practice;
